import React from 'react';
import { CheckIcon, BookOpenIcon, MessagesSquareIcon } from 'lucide-react';
import { Section, Reveal } from './Section';
const checks = ['Explicaciones simples, sin hacerte sentir que llegaste tarde.', '3 formas claras de empezar a poner en orden tus decisiones.', 'Cómo practicar y observar antes de usar dinero real.', 'Herramientas para cuidar tu plata desde el primer día.', 'Ejemplos reales explicados, con lo que salió bien y lo que no.'];
export function SolutionSection() {
  return <Section id="solucion" className="border-y border-white/5 bg-ink-900" data-id="element-226" data-mp="3t8n8k0h7ap4d">
      <Reveal data-id="element-227" data-mp="3t6kft8onyhvy">
        <h2 className="font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl lg:text-4xl" data-id="element-228" data-mp="au4hyf17sxhm">
          <span aria-hidden="true" data-id="element-229" data-mp="5v1bqr9i0l82">🏆</span>  Capital Consciente  + Discord + 3 Bonos
        </h2>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-gray-400 sm:text-lg" data-id="element-230" data-mp="krsdv8ak4b1d">
          Capital Consciente no promete resultados mágicos. Es una forma clara de aprender lo que verías en una mentoría privada: entender tu dinero, tomar decisiones más pensadas y empezar sin sentirte perdido. La idea es que, con tiempo, puedas construir más respaldo para tus planes y para esos gastos que no avisan, sin pagar una barrera de entrada de $500 USD.
        </p>
      </Reveal>

      <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-231" data-mp="3ka5aoatik1e5">
        <Reveal delay={0.05} data-id="element-232" data-mp="3kboqy1f66cfx">
          <div className="h-full rounded-2xl border border-white/10 bg-ink-850 p-6" data-id="element-233" data-mp="3p9ht8jdcqmax">
            <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-brand-soft" data-id="element-234" data-mp="3p7ni1wrvu8k1">
              <BookOpenIcon className="h-5 w-5 text-brand" data-id="element-235" data-mp="3u68c1egjjw01" />
            </div>
            <h3 className="font-display text-lg font-bold text-white" data-id="element-236" data-mp="2uoxfnhee8ad">
              📘 Ebook
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-gray-400" data-id="element-237" data-mp="6xbklb34j518">
              Bases simples + 3 formas de empezar + una guía para practicar antes de poner dinero.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.12} data-id="element-238" data-mp="2cwt63ppoy16j">
          <div className="h-full rounded-2xl border border-white/10 bg-ink-850 p-6" data-id="element-239" data-mp="2cxuran0f841z">
            <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-brand-soft" data-id="element-240" data-mp="27y8c48118dqj">
              <MessagesSquareIcon className="h-5 w-5 text-brand" data-id="element-241" data-mp="2mmw4y6jhu9cs" />
            </div>
            <h3 className="font-display text-lg font-bold text-white" data-id="element-242" data-mp="2hw5zyuezc8im">
              💬 Discord
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-gray-400" data-id="element-243" data-mp="2vmj9303lxt9j">
              Conversaciones y actualizaciones para seguir aprendiendo. No señales, no promesas.
            </p>
          </div>
        </Reveal>
      </div>

      <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-244" data-mp="35k5nllgzvisz">
        {checks.map((c, i) => <Reveal key={c} delay={i * 0.05} data-id="element-245" data-mp="30m48fbmow3ms" data-mpi={i}>
            <li className="flex items-start gap-3" data-id="element-246" data-mp="30kaz1okoz5b3">
              <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-brand-soft" data-id="element-247" data-mp="1b6o20405gw0l">
                <CheckIcon className="h-4 w-4 text-brand" data-id="element-248" data-mp="169o2kbxt2rig" />
              </span>
              <span className="text-sm text-gray-300 sm:text-base" data-id="element-249" data-mp="3hvgb7668biap">{c}</span>
            </li>
          </Reveal>)}
      </ul>
    </Section>;
}